import * as Yup from 'yup';

const validationSchema = () => {
  return Yup.object({
    password: Yup.string()
      .required('passwordInput.validationError.fieldEmpty')
      .min(6, 'passwordInput.validationError.passwordMinLength'), // t('passwordInput.validationError.fieldEmpty') t('passwordInput.validationError.passwordMinLength') <- for i18n-unused
  });
};

export default validationSchema;
